import { render, staticRenderFns } from "./LeaderManualQuestionnaireAnswer.vue?vue&type=template&id=3081b55a&scoped=true&"
import script from "./LeaderManualQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
export * from "./LeaderManualQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderManualQuestionnaireAnswer.vue?vue&type=style&index=0&id=3081b55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3081b55a",
  null
  
)

export default component.exports